import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import './RackHeightsSheet.scss';

import { getCurrentMeet } from 'selectors';
import { getSessionOptions } from 'util/options';
import { getBenchLabel } from 'util/meetHelper';

class RackHeightsSheet extends Component {

  render() {
    const { meet } = this.props;

    const lifters = _.sortBy(meet.lifters, ['name']);

    return (
      <div className="rack-heights-sheet">
        {
          _.map(getSessionOptions(), (session) => {
            const sessionLifters = _.filter(lifters, {session: session.value});
            const sessionCount = _.size(sessionLifters);
            if(!sessionCount) {
              return null;
            }

            return (
              <div key={session.value} className="session-pages">
                <div className="meet-name">{meet.date} - {meet.name} - Session {session.value} - RACK HEIGHTS</div>
                <table>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Squat Rack</th>
                      <th>Squat In/Out</th>
                      <th>{getBenchLabel(meet)} Rack</th>
                      { meet.federation !== 'USSF' && <th>Bench Saftey</th> }
                      { meet.federation !== 'USSF' && <th>Bench Foot Blocks</th> }
                      <th>Lifter/Coach Signature</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      _.map(sessionLifters, (lifter) => {
                        return (
                          <tr key={lifter._id}>
                            <td>{lifter.name}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            { meet.federation !== 'USSF' && <td></td> }
                            { meet.federation !== 'USSF' && <td></td> }
                            <td></td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
            );
          })
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(RackHeightsSheet);
